import React, { useState, useEffect, memo } from "react";
import { withStyles, Grid, Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import TextField from "../../../../../../Component/Forms/TextField";
import DateField from "../../../../../../Component/Forms/DateField";
import MultiSelect from "../../../../../../Component/Forms/MultiSelect";

import { recordTypes as rts } from "../../../../../../API/config";
import { useTranslation } from "react-i18next";
import { styles } from "./styles";

const Search = (props) => {
  const { handleFilterChange, classes } = props;

  const [rtActions, setRtActions] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [user, setUser] = useState();
  const [actions, setActions] = useState([]);
  const [fromDateTime, setFromDateTime] = useState();
  const [toDateTime, setToDateTime] = useState();

  const { t } = useTranslation();

  useEffect(() => {
    const rtActions = [];
    const actionNames = [];
    for (let rt in rts) {
      for (let a in rts[rt].actions) {
        if (rts[rt].actions[a].auditable) {
          if (actionNames.indexOf(rts[rt].actions[a].label) < 0) {
            rtActions.push(rts[rt].actions[a]);
            actionNames.push(rts[rt].actions[a].label);
          }
        }
      }
    }
    setActionList(actionNames.sort());
    setRtActions(rtActions);
  }, []);

  const search = () => {
    const actionValues = rtActions
      .filter((a) => actions.indexOf(a.label) > -1)
      .map((a) => a.name);

    handleFilterChange({
      user,
      actions: actionValues,
      fromDateTime,
      toDateTime,
    });
  };

  const onActionChange = (values) => {
    setActions(values || []);
  };

  return (
    <div className={classes.pageHeaderContainer}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField
            label={t("labels.audit.searchForm.user")}
            initialValue={user}
            type="text"
            onChange={setUser}
          />
        </Grid>
        <Grid item xs={3}>
          <MultiSelect
            label={t("labels.audit.searchForm.actions")}
            options={actionList}
            initialValues={actions || []}
            changeHandler={onActionChange}
          />
        </Grid>
        <Grid item xs={3}>
          <DateField
            label={t("labels.audit.searchForm.dateRangeFrom")}
            isRequired={true}
            labelErrorText={""}
            initialValue={fromDateTime}
            onChange={(d) => setFromDateTime(d)}
          />
        </Grid>
        <Grid item xs={3}>
          <DateField
            label={t("labels.audit.searchForm.dateRangeTo")}
            isRequired={true}
            labelErrorText={""}
            initialValue={toDateTime}
            onChange={(d) => setToDateTime(d)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={10}></Grid>
        <Grid item xs={2}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <Button
              color="primary"
              variant="contained"
              style={{ height: 35 }}
              onClick={search}
            >
              <SearchIcon />
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(memo(Search));
